module.exports = __webpack_public_path__ + "a01968cac34512eb7f4930a45683a06c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Homepage/homepage_bubble.png
 ** module id = 312
 ** module chunks = 0
 **/